import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import { Modal } from "@mui/material";

import classes from "./index.module.css";

const Sidebar = ({ locationName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [openModal, setOpenModal] = useState(false);

  const active = ({ isActive }) => {
    return {
      backgroundColor: isActive ? "#f5faff" : "white",
      borderRadius: isActive ? "13px" : "none",
    };
  };

  return (
    <>
      {locationName.includes("admin") ? (
        <div className={classes["container"]}>
          <h2 className={classes["title"]}>{t("249-School")}</h2>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/admin-panel/statistics"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="fluent:arrow-growth-20-filled" />
              <p className={classes["text"]}>Statistics</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/admin-panel/teachers"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="bxs:user" />
              <p className={classes["text"]}>Teachers</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/admin-panel/students"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="ph:student-fill" />
              <p className={classes["text"]}>Students</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/admin-panel/events"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="mdi:events-check" />
              <p className={classes["text"]}>Events</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/admin-panel/cameras"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="mdi:camera" />
              <p className={classes["text"]}>Camera</p>
            </div>
          </NavLink>
          <div className={classes["box"]} onClick={() => setOpenModal(true)}>
            <Icon className={classes["icon"]} icon="solar:exit-bold" />
            <p className={classes["text"]}>Log Out</p>
          </div>
          <Modal open={openModal} onClose={() => setOpenModal(false)}>
            <div className={classes["confirm-modal"]}>
              <p className={classes["modal-title"]}>Are you sure ?</p>
              <div className={classes["button-wrappers"]}>
                <button
                  onClick={() => setOpenModal(false)}
                  className={`${classes["button"]} ${classes["cancel-button"]}`}
                >
                  Cancel
                </button>
                <button
                  onClick={() => navigate("/login")}
                  className={`${classes["button"]} ${classes["confirm-button"]}`}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        <div className={classes["container"]}>
          <h2 className={classes["title"]}>{t("249-School")}</h2>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/student-panel/library"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="bxs:user" />
              <p className={classes["text"]}>Library</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/student-panel/lessons"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="mdi:events-check" />
              <p className={classes["text"]}>lessons</p>
            </div>
          </NavLink>
          <NavLink
            className={classes["link"]}
            style={active}
            to={"/student-panel/camera"}
          >
            <div className={classes["box"]}>
              <Icon className={classes["icon"]} icon="mdi:camera" />
              <p className={classes["text"]}>Camera</p>
            </div>
          </NavLink>
          <div className={classes["box"]} onClick={() => setOpenModal(true)}>
            <Icon className={classes["icon"]} icon="solar:exit-bold" />
            <p className={classes["text"]}>Log Out</p>
          </div>
          <Modal open={openModal} onClose={() => setOpenModal(false)}>
            <div className={classes["confirm-modal"]}>
              <p className={classes["modal-title"]}>Are you sure ?</p>
              <div className={classes["button-wrappers"]}>
                <button
                  onClick={() => setOpenModal(false)}
                  className={`${classes["button"]} ${classes["cancel-button"]}`}
                >
                  Cancel
                </button>
                <button
                  onClick={() => navigate("/login")}
                  className={`${classes["button"]} ${classes["confirm-button"]}`}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default Sidebar;
